module.exports = __webpack_public_path__ + "img/sinfoto.3708994b.jpg";